import Container from 'components/Container'
import { SkeletonItem } from 'components/Skeleton'

export const PlanSkeleton = () => (
	<Container space="md" spaceDirection="vertical">
		<SkeletonItem />
		<SkeletonItem />
		<SkeletonItem />
	</Container>
)
